import createHistory from 'history/createBrowserHistory';

const history = createHistory({
  basename: process.env.REACT_APP_BASE_PATH,
});

/**
 * Generate a function that can be used to override an original history function (push/replace).
 * The override makes sure that `location.search` is persisted when omitted.
 *
 * @param {Function} callback The function to proxy to
 */
const generateHistoryFunc = (callback) =>
  (path, state) => {
    if (typeof path === 'string') {
      path = { pathname: path };
    }
    if (path.search === undefined) {
      path.search = history.location.search;
    }
    return callback(path, state);
  }

// backup functions
history._push = history.push;
history._replace = history.replace;

// override original functions
history.push = generateHistoryFunc(history._push);
history.replace = generateHistoryFunc(history._replace);

export default history;



// WEBPACK FOOTER //
// ./src/util/history.js